
const baseUrl = !!process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:8000';

const config = {
    baseUrl,
    apiUrl: `${baseUrl}/api/v1`,
};

export { config };



// WEBPACK FOOTER //
// ./src/_config/global.config.js